module.exports = __webpack_public_path__ + "static/media/JMIQuickVUEVirtualLogo.a79b6000.png";